import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Http } from "@status/codes";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { DashboardTemplateResponse } from "../DashboardTemplate/models/DashboardTemplateResponse";
import { BqDashboardService } from "../DashboardTemplate/services/BqDashboardService";
import { DASHBOARD_TEMPLATE_EVENTS } from "../DashboardTemplate/constants/DashboardTemplatesConstants";
import DashboardGridLayout from "../DashboardTemplate/components/DashboardView/DashboardGridLayout/DashboardGridLayout .vue";
import { SearchContext } from "@/shared/models/SearchContext";
import {
  DASHBOARD_FILTERS,
  PAGE_DASHBOARD_TITLE_SEARCH
} from "../Dashboards/constants/DashboardConstants";
import { LIST_DATA_EVENTS } from "@/shared/constants/FormConstants";
import {
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import store from "@/store";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { DashboardAIViewContext } from "@/shared/models/AIViewContext";
import { createDashboardAIContext } from "./services/DashboardContextAdapter";
import { SectionOfDashboard } from "../DashboardTemplate/models/SectionOfDashboard";

@Component({
  name: "Dashboard",
  components: { DynamicSelect, DashboardGridLayout },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Dashboard extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;

  dataToMainView!: MenuDataStructure;

  template = [] as DynamicSelectData[];
  templateOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "Seleccionar plantilla",
    hideDetails: false,
    attach: false,
    limit: 3,
    required: true
  };
  dashboardTemplate: DashboardTemplateResponse = new DashboardTemplateResponse();
  dashboardContext?: DashboardAIViewContext;
  loading = false;
  filterArray = DASHBOARD_FILTERS.MAIN;
  querySearch = { type: [""], name: [""], state: [""] };

  get conversationKey(): string {
    return this.$route.params.id || "general";
  }

  mounted() {
    this.getAllTemplates();
    this.emitSearchInitializer();
  }

  async emitSearchInitializer() {
    await this.initializeFilters();

    const searchContext: SearchContext = {
      title: PAGE_DASHBOARD_TITLE_SEARCH,
      filterArray: [this.filterArray],
      operations: [],
      clickAction: LIST_DATA_EVENTS.VIEW_DATA,
      componentName: "El dashboard",
      callbackHandleOperation: this.handleOperation,
      descriptions: ["state"]
    };
    const data = searchContext;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  async initializeFilters() {
    const secondaryFilters = [];
    secondaryFilters.push(DASHBOARD_FILTERS.SECONDARY.NAME);
    secondaryFilters.push(DASHBOARD_FILTERS.SECONDARY.STATUS);
    secondaryFilters.push(DASHBOARD_FILTERS.SECONDARY.TYPE);
    this.filterArray.secondaryFilters = secondaryFilters;
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.onTemplateChange(itemId);
        break;
    }
  }

  // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };

    validations[this.dataToMainView.from];
  }

  panelValidation() {
    /* istanbul ignore else */

    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getAllTemplates(true);
          break;
      }
    }
  }
  async getAllTemplates(search?: boolean) {
    if (search) {
      this.templateOptionsConfig.listAll = [];
    }
    this.loading = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );
    console.log("search", this.querySearch);
    let type: string | undefined = undefined;
    let name: string | undefined = undefined;
    let status: string | undefined = undefined;
    if (this.querySearch.type) {
      type = this.querySearch.type[0];
    }
    if (this.querySearch.name) {
      name = this.querySearch.name[0];
    }
    if (this.querySearch.state) {
      status = this.querySearch.state[0];
    }
    console.log("name", name);
    const response = await this.bqDashboardService.getAllTemplates(
      type,
      name,
      status
    );
    if (response.code == Http.Found) {
      this.templateOptionsConfig.listAll = (response.data as unknown) as DynamicSelectData[];
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        response.data
      );
    }
    this.loading = false;
  }
  async onTemplateChange(templateId: string) {
    this.$store.commit("chatassistant/setSelectedDashboardId", {
      key: this.conversationKey,
      dashboardId: templateId
    });
    this.$store.commit("chatassistant/setActiveViewLoading", {
      key: this.conversationKey,
      loading: true
    });
    this.$store.commit(
      DASHBOARD_TEMPLATE_EVENTS.CLEAN_ALL_DATA_OF_DASHBOARD_TEMPLATE
    );
    this.dashboardContext = undefined;
    this.loading = true;
    const templateResponse = await this.bqDashboardService.getTemplateById(
      templateId
    );
    this.loading = false;
    if (templateResponse.code == Http.Found) {
      this.dashboardTemplate = {
        ...templateResponse.data,
        templateId
      };
    } else {
      this.$store.commit("chatassistant/setSelectedDashboardId", {
        key: this.conversationKey,
        dashboardId: undefined
      });
      this.$store.commit(
        "chatassistant/clearActiveViewContext",
        this.conversationKey
      );
    }
  }

  handleDashboardRender(sections: SectionOfDashboard[]) {
    if (!this.dashboardTemplate.templateId || !this.dashboardTemplate.name) {
      this.dashboardContext = undefined;
      this.$store.commit(
        "chatassistant/clearActiveViewContext",
        this.conversationKey
      );
      return;
    }

    this.dashboardContext = createDashboardAIContext({
      dashboardId: this.dashboardTemplate.templateId,
      dashboardName: this.dashboardTemplate.name,
      sections
    });
    this.$store.commit("chatassistant/setActiveViewContext", {
      key: this.conversationKey,
      context: this.dashboardContext
    });
  }

  beforeDestroy() {
    this.$store.commit("chatassistant/setSelectedDashboardId", {
      key: this.conversationKey,
      dashboardId: undefined
    });
    this.$store.commit(
      "chatassistant/clearActiveViewContext",
      this.conversationKey
    );
  }

  get showDashboard(): boolean {
    return this.dashboardTemplate && !!this.dashboardTemplate.name;
  }
}
